import { LoggerService } from './../../Services/logger.service';
import { OdataService } from '@app/Services/o-data.service';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { DASHBOARD_IMAGES } from '@app/Shared/constants/td-constants';
import { iButtonItem, MenuItem } from '@app/Shared/interfaces/iMenu';
import { Subscription } from 'rxjs';
import { Stream } from 'stream';
import { ThemeService } from '@app/Services/Utilities/theme.service';
import { AuthService } from '@app/Services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { iParsedEntity } from '@app/Shared/interfaces/iEntityParsed';
import { Store } from '@ngrx/store';
import { AppState } from '@app/Store';
import * as DashboardActions from '@app/Store/actions/dashboard-actions';
import { MatMenu } from '@angular/material/menu';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
    public logo: string = DASHBOARD_IMAGES.MENU_LOGO;
    public buttonList: iButtonItem[] = [];
    public data: string = ''; //declaring: similar to let const var
    public subscriptionButtonList!: Subscription; // Implements and manages subscriptions
    public themeState: boolean = false;
    public userInfo: any;
    public userLogo: string = '/assets/images/user-logo.png';
    public appVersion: string = '1.0.0';

    // Navigation detection
    public isNewDataExplorerPage = false;

    // Navigation menu items - all menus read from array
    menuItems: MenuItem[] = [
        {
            title: 'Data Explorer',
            page: '/new-data-explorer',
            iconClass: 'table_chart',
        },
        {
            title: 'Settings',
            page: '/settings',
            iconClass: 'settings',
        },
        {
            title: 'Configuration',
            iconClass: 'admin_panel_settings',
            submenus: [
                {
                    title: 'Sources',
                    page: '/configuration/sources',
                    iconClass: 'source',
                },
                {
                    title: 'Rule Management',
                    page: '/configuration/rule-management',
                    iconClass: 'manage_accounts',
                },
            ],
        },
    ];

    menuItemsFooter: MenuItem[] = [{ title: 'Log out', page: '/logout', iconClass: 'logout' }];

    @ViewChildren('navMenu') menuPanels!: QueryList<MatMenu>;

    //injecting the service
    constructor(
        private oDataService: OdataService,
        private loggerService: LoggerService,
        private themeService: ThemeService,
        private authService: AuthService,
        private router: Router,
        private store: Store<AppState>,
        private http: HttpClient
    ) {}
    ngOnInit(): void {

        this.subscriptionButtonList = this.oDataService.getButtonList().subscribe((buttonData) => {
            this.buttonList = buttonData;
        });

        // Get user info
        this.authService.userInfoSubject$.subscribe((info) => {
            this.userInfo = info;
        });

        // Check if we're on New Data Explorer page
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            const url = this.router.url.split('?')[0]; // Remove query params
            this.isNewDataExplorerPage = url === '/' || url === '/new-data-explorer' || url === '/new-data-explorer/';
        });

        // Initial check on component init
        const url = this.router.url.split('?')[0];
        this.isNewDataExplorerPage = url === '/' || url === '/new-data-explorer' || url === '/new-data-explorer/';
    }

    ngOnDestroy(): void {
        this.subscriptionButtonList.unsubscribe();
    }


    public onEntitySelected(entity: iParsedEntity): void {
        // Handle entity selection if needed
        console.log('Entity selected in header:', entity);

        // Dispatch action to set selected entity in store
        this.store.dispatch(DashboardActions.selectedEntity({ selectedEntity: entity }));
    }
    public onThemeStateChange(state: boolean): void {
        this.themeService.changeTheme(state);
    }

    // Helper methods to handle different user info structures
    getDisplayName(): string {
        if (!this.userInfo) return 'User';

        if (this.userInfo.first_name && this.userInfo.last_name) {
            return `${this.userInfo.first_name} ${this.userInfo.last_name}`;
        } else if (this.userInfo.name) {
            return this.userInfo.name;
        } else if (this.userInfo.username) {
            return this.userInfo.username;
        } else if (this.userInfo.displayName) {
            return this.userInfo.displayName;
        }

        return 'User';
    }

    getUserRole(): string {
        if (!this.userInfo) return 'Guest';

        if (this.userInfo.account_type) {
            return this.userInfo.account_type;
        } else if (this.userInfo.role) {
            return this.userInfo.role;
        } else if (this.userInfo.roles && this.userInfo.roles.length > 0) {
            return this.userInfo.roles[0];
        }

        return 'User';
    }

    getUserEmail(): string {
        if (!this.userInfo) return '';

        if (this.userInfo.email) {
            return this.userInfo.email;
        } else if (this.userInfo.username) {
            return `${this.userInfo.username}@truedata.com`;
        }

        return '';
    }
    // Check if any submenu is active
    isSubmenuActive(submenus?: MenuItem[]): boolean {
        if (!submenus) return false;
        return submenus.some((submenu) => submenu.page && this.router.url.includes(submenu.page));
    }

    // Get menu reference by index - only for items with submenus
    getMenuByIndex(index: number): MatMenu | undefined {
        if (!this.menuPanels || this.menuPanels.length === 0) return undefined;
        // Find the position of this index in the list of items with submenus
        const itemsWithSubmenus = this.menuItems.map((item, i) => ({ item, index: i })).filter(({ item }) => item.submenus && item.submenus.length > 0);
        const menuPosition = itemsWithSubmenus.findIndex(({ index: idx }) => idx === index);
        if (menuPosition >= 0 && menuPosition < this.menuPanels.length) {
            return this.menuPanels.toArray()[menuPosition];
        }
        return undefined;
    }
}
